import React from "react";
import Text from "src/components/text";

import { formatTimespent, calculatePercentage } from "src/services/reports.service";
import { CreatedBy, ShareItem } from "src/types/reports";

import _ from "lodash";
import styles from "./conversationCard.module.scss";

const DefaultAssetIcon = "/images/defaultIcons/default_asset.jpg";

export interface ConversationActivityItem {
  share: ShareItem;
  createdBy: CreatedBy;
  totalAssetsCount: number;
  totalRecipients: number;
}

interface ConversationActivityCardProps {
  item: ConversationActivityItem;
}

const ConversationActivityCard: React.FC<ConversationActivityCardProps> = ({
  item,
}) => {
  const { share, createdBy, totalRecipients } = item;

  const openRate = calculatePercentage(share.uniqueEmailOpens, totalRecipients);

  const clickRate = calculatePercentage(share.uniqueLinkClicks, totalRecipients);

  return (
    <a
      href={`/conversations/${share?.id}`}
      target="_blank"
      rel="noopener noreferrer"
      className={styles.linkWrapper}
    >
      <div className={styles.card}>
        <img
          src={share?.icon?.thumbnail || DefaultAssetIcon}
          className={styles.thumbnailIcon}
          alt={share.subject}
        />
        <div className={styles.content}>
          <Text text={share?.subject} className={styles.title} lines={1} />
          <div className={styles.metrics}>
            <span>
              {openRate} Open Rate
            </span>
            <span>
              {clickRate} Click Rate
            </span>
            <span>
            {formatTimespent(share?.totalTimeSpent || 0) || "00:00"} Time Spent
            </span>
          </div>
          <div className={styles.meta}>
            Shared by:{" "}
            <Text
              text={`${createdBy.firstName} ${createdBy.lastName}`}
              className={styles.author}
              lines={1}
            />
          </div>
        </div>
      </div>
    </a>
  );
};

export default ConversationActivityCard;
